class MobileColumnsToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const formEl = this.querySelector('form');

    const productGridWrapper = document.querySelector('#product-grid')

    formEl.addEventListener('change', event => {

      const newColumnCount = formEl['mobile-columns'].value;

      if (newColumnCount == '2') {
        productGridWrapper.classList.add('grid--2-col-tablet-down');
        productGridWrapper.classList.remove('grid--1-col-tablet-down');
      } else {
        productGridWrapper.classList.add('grid--1-col-tablet-down');
        productGridWrapper.classList.remove('grid--2-col-tablet-down');
      }
    });
  }
}

customElements.define('mobile-columns-toggle', MobileColumnsToggle);
